module.exports = __webpack_public_path__ + "img/maisonette-flyer.eaf4d43f.webp";